/**
 * Terms of Service / Acceptable Use Policy text and per-user acceptance.
 */

import apiClient from './client';

export interface LegalDocument { id: 'acceptable-use' | 'terms' | 'privacy'; title: string; markdown: string }
export interface LegalDocuments { version: string; draft: boolean; sha256: string; documents: LegalDocument[] }
export interface LegalAcceptance { version: string; sha256: string; draft: boolean; accepted: boolean; accepted_at: string | null }

/** Public: the current documents (no sign-in required). */
export async function getLegalDocuments(): Promise<LegalDocuments> {
  const { data } = await apiClient.get<LegalDocuments>('/legal');
  return data;
}

/** Whether the signed-in user has accepted the current version. */
export async function getLegalAcceptance(): Promise<LegalAcceptance> {
  const { data } = await apiClient.get<LegalAcceptance>('/legal/acceptance');
  return data;
}

/** Record acceptance of the exact version the user was shown. */
export async function acceptLegal(version: string, sha256: string): Promise<LegalAcceptance> {
  const { data } = await apiClient.post<LegalAcceptance>('/legal/acceptance', { version, sha256 });
  return data;
}
